/**
 * Rendert aktive Filter als Tags und ermöglicht das Entfernen einzelner Filter per Klick.
 */
export function renderTags(active, filters, items) {
    const activeFiltersEl = document.getElementById("active-filters");
    if (!activeFiltersEl) return;

    activeFiltersEl.innerHTML = "";

    Object.entries(active).forEach(([key, values]) => {
        if (key === "sortierung") return;

        values.forEach((val) => {
            const tag = document.createElement("div");

            const input = document.querySelector(
                `.filter[data-filter="${CSS.escape(key)}"] input[value="${CSS.escape(val)}"]`
            );

            let labelText = String(val);

            if (input) {
                const labelEl = input.closest("label");
                if (labelEl) {
                    const cloned = labelEl.cloneNode(true);
                    cloned.querySelectorAll("input, .option-count").forEach((node) => node.remove());
                    labelText = cloned.textContent.trim();
                }
            }

            const text = document.createElement("span");
            text.textContent = `${labelText} `;
            tag.appendChild(text);

            const icon = document.createElement("i");
            icon.className = "icon icon-close";
            tag.appendChild(icon);

            tag.onclick = () => {
                if (input) {
                    input.checked = false;
                }
                document.dispatchEvent(new Event("change"));
            };

            activeFiltersEl.appendChild(tag);
        });
    });
}